import { createContext } from '@lyearn/core/utils/context';

import { MediaContextProps } from '../types';

const [MediaContextProvider, useMediaContext] = createContext<MediaContextProps>('MediaContext');

export { useMediaContext };
export default MediaContextProvider;
